import React from "react";

const DonateSuccess = ({amount})=>{

return(

<div className="d_donate_thankyou">

<h1>🙏 Thank You</h1>

<p>Your donation was successful.</p>

<h2>Amount Donated: ₹{amount}</h2>

<button
className="d_donate_btn"
onClick={()=>window.location.href="/"}
>
Go Home
</button>

</div>

);

};

export default DonateSuccess;